import React, { useCallback } from 'react';
import { ApplicationsConstants } from '@utils/applicationsConstants';
import { Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const useNavigateToActionsMsg = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('invoices');

  const navigateTo = useCallback(
    (operationProtocol: string) => {
      message.destroy('invoice-actions');
      navigate(
        `/${ApplicationsConstants.MOT_ENTERPRISE}/mobile-network/financial/invoices/actions?protocol=${operationProtocol}`,
      );
    },
    [navigate],
  );

  const navigateToActionsMsg = useCallback(
    (operationProtocol: string) =>
      message.success({
        content: (
          <span>
            {t('actions.request-success')}
            <Button
              onClick={() => {
                navigateTo(operationProtocol);
              }}
              type="link"
              style={{ padding: 3 }}
            >
              {`${t('actions.go-to')}, `}
            </Button>
            {t('actions.check-progress')}
          </span>
        ),
        key: 'invoice-actions',
        duration: 5,
      }),
    [navigateTo, t],
  );

  return { navigateToActionsMsg };
};

export default useNavigateToActionsMsg;
